import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';
import { MARKED_OPTIONS, MarkdownModule } from 'ngx-markdown';

import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { gfMarkedOptionsFactory } from '../../core/services/core.markdown-editor.service';
import { FLOW_STATES } from './flow.routes.config';
import { ChatComponent } from './chat/chat.component';
import { TopicListComponent } from './topic-list/topic-list.component';
import { MessageListComponent } from './message-list/message-list.component';
import { MessageComponent } from './message/message.component';
import { ThinkingIndicatorComponent } from './message/thinking-indicator.component';
import { ToolBubbleComponent } from './message/tool-bubble.component';
import { ChatFlowService } from './services/chat.flow.service';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        CoreWidgetsModule,
        CoreFiltersModule,
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MARKED_OPTIONS,
                useFactory: gfMarkedOptionsFactory
            }
        }),
        UIRouterModule.forChild({ states: FLOW_STATES })
    ],
    declarations: [
        ChatComponent,
        TopicListComponent,
        MessageListComponent,
        MessageComponent,
        ThinkingIndicatorComponent,
        ToolBubbleComponent
    ],
    providers: [
        ChatFlowService
    ],
})
export class FlowModule {
    constructor() {}
}
